import { Field, Label, Select } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import clsx from 'clsx'

export default function SelectInput({label, value, onChange, name, data = [], description}) {
  return (
    <div className="w-full">
      <Field>
        <Label className="text-sm/6 font-medium">{label}</Label>
        {/* <Description className="text-sm/6">{selectStatement}</Description> */}
        <div className="relative w-full">
          <Select
          value={value}
          onChange={onChange}
          name={name}
            className={clsx(
              'mt-3 block w-full rounded-lg appearance-none h-12 border-gray-300 py-1.5 px-3 text-sm/6 border-[1px] ',
              'focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-black/25 cursor-pointer',
              '*:text-black'
            )}
          >
           {
            description &&  <option>{description}</option>
           }
            {
                data.map((item, index) => (
                    <option className='' key={index} value={item.value?? item}>{item.name?? item}</option>
                ))
            }
          </Select>
          <ChevronDownIcon
            className="group pointer-events-none absolute top-4 right-2.5 size-4 fill-black/60"
            aria-hidden="true"
          />
        </div>
      </Field>
    </div>
  )
}
